import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";

import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {ImageIntroPage} from "./ImageIntroPage";
import {ElGordosRevenge} from "../ElGordosRevenge";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";

export class ElGordosRevengeIntroConfig implements GameIntroViewConfig {

    colors:GameIntroColors = {
        slideShowColors : {
            backgroundColor : 0x000000, //Default 0x000000
            backgroundAlpha : 0.4, //Default 0.4
            bulletColor : 0xffffff, //Default 0xffffff

        },
        stampColor : 0xFFFFFF
    };

    stampConfig:StampConfig = {
        xNudge : true,
        xSplit : true,
        xBet : true,
        xRip : true,
        volatility : Volatility.INSANE
    };

    background:PIXI.Container;
    borderBottom:PIXI.Container;
    borderTop:PIXI.Container;
    logo:PIXI.Container;
    pages:SlideShowPage[];

    constructor() {
    }

    public init():Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add("introBg", "resources/images/Intro_BG.jpg");
        imgLoader.add("introDiv", "resources/images/Intro_Divider.png");
        imgLoader.add("logo", "resources/images/introLogo.png");
        imgLoader.add("fs", "nolimit/screens/images/Freespin.png");
        imgLoader.add("sfs", "nolimit/screens/images/Massacre_spins.png");
        imgLoader.add("xNudge", "nolimit/screens/images/xNudge.png");
        imgLoader.add("wilds", "resources/images/Wilds.png");
        imgLoader.add("quickDraw", "resources/images/Cylinder_feature.png");
        imgLoader.add("quickDraw_US", "resources/images/Cylinder_feature_US.png");
        imgLoader.add("capWin", "resources/images/capwin.png");


        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    private initGraphics() {
        this.background = new PIXI.Container();
        const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introBg"));
        bgSprite.anchor.set(0.5, 0.5);
        this.background.addChild(bgSprite);

        this.borderTop = new PIXI.Container();
        const topSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
        topSprite.anchor.set(0.5, 0.5);
        this.borderTop.addChild(topSprite);

        this.borderBottom = new PIXI.Container();
        const bottomSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
        bottomSprite.rotation = Math.PI;
        bottomSprite.anchor.set(0.5, 0.5);
        this.borderBottom.addChild(bottomSprite);

        this.logo = new PIXI.Container();
        const logoSprite = new PIXI.Sprite(ImgLoader.getImgTexture("logo"));
        logoSprite.anchor.set(0.5, 1);
        logoSprite.y = 48;
        this.logo.addChild(logoSprite);

        this.pages = [
            new ImageIntroPage([
                {
                    texture : ImgLoader.getImgTexture("fs"),
                    scale : 0.85,
                    position : new PIXI.Point(-170, -20)
                },
                {
                    texture : ImgLoader.getImgTexture("sfs"),
                    scale : 0.8,
                    position : new PIXI.Point(170, 20)
                }
            ]),
            new ImageIntroPage([
                {
                    texture : ImgLoader.getImgTexture("xNudge"),
                    scale : 1,
                    position : new PIXI.Point(-160, 0)
                },
                {
                    texture : ImgLoader.getImgTexture("wilds"),
                    scale : 0.9,
                    position : new PIXI.Point(160, 0)
                }
            ])
        ];

        if(ElGordosRevenge.apiPlugin.gameClientConfiguration.isSet) {
            this.addConditionalPages();
        } else {
            ElGordosRevenge.apiPlugin.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                this.addConditionalPages();
            });
        }
    }

    private addConditionalPages():void {
        if(!ElGordosRevenge.apiPlugin.gameClientConfiguration.replaceWincapInfo) {
            const capwinPage = new ImageIntroPage([
                {
                    texture : ImgLoader.getImgTexture("capWin"),
                    scale : 1,
                    position : new PIXI.Point(0, 0)
                }
            ]);

            this.pages.splice(0, 0, capwinPage);
        }

        this.pages.push(new ImageIntroPage([
            {
                texture : ImgLoader.getImgTexture(`quickDraw${ElGordosRevenge.apiPlugin.gameClientConfiguration.showMultipliersInfo? "": "_US"}`),
                scale : 0.9,
                position : new PIXI.Point(0, 0)
            }
        ]));
    }
}